export default {
  dtInventory: {
    label: 'Data',
    type: 'general',
    field: 'dtInventory',
    align: 'left',
    customWidth: 150,
    render: true,
    fixed: false,
    disableOrder: false,
  },

  dsBranch: {
    label: 'Loja',
    field: 'dsBranch',
    type: 'general',
    align: 'left',
    customWidth: 150,
    fixed: false,
    render: true,
    disableOrder: true,
  },

  cdLm: {
    label: 'LM',
    field: 'cdLm',
    type: 'general',
    align: 'left',
    customWidth: 100,
    fixed: false,
    render: true,
    disableOrder: true,
  },

  dsProduct: {
    label: 'Descrição',
    field: 'dsProduct',
    type: 'general',
    align: 'left',
    customWidth: 200,
    fixed: false,
    render: true,
    disableOrder: true,
    fullWidth: true
  },

  section: {
    label: 'Seção',
    field: 'section',
    type: 'general',
    align: 'left',
    customWidth: 230,
    fixed: false,
    render: true,
    disableOrder: true,
  },

  listType: {
    label: 'Tipo de Lista',
    field: 'listType',
    type: 'general',
    align: 'left',
    customWidth: 150,
    fixed: false,
    render: true,
    disableOrder: true,
  },

  c50Formatted: {
    label: 'Estoque Sistema',
    field: 'c50Formatted',
    type: 'general',
    align: 'left',
    customWidth: 150,
    fixed: false,
    render: true,
    disableOrder: true,
  },

  dpac: {
    label: 'DPAC',
    field: 'dpac',
    type: 'general',
    align: 'left',
    customWidth: 150,
    fixed: false,
    render: true,
    disableOrder: true,
  },

  warehouse: {
    label: 'Depósito',
    field: 'warehouse',
    type: 'general',
    align: 'left',
    customWidth: 150,
    fixed: false,
    render: true,
    disableOrder: true,
  },

  dsProvider: {
    label: 'Fornecedor',
    field: 'dsProvider',
    type: 'general',
    align: 'left',
    customWidth: 180,
    fixed: false,
    render: true,
    disableOrder: true,
  },
}
